import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {Advertiser} from '../../models/advertiser';

@Injectable({
  providedIn: 'root'
})
export class AdvertiserService extends AbstractModelService<Advertiser> {

  constructor(apiClient: ApiClientService) {
    super(apiClient, '/advertiser', Advertiser);
  }
}
